import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import axios from "axios";
import {TabView, TabPanel} from 'primereact/tabview';
import ContactShowComponent from './ContactShowComponent';

const ContactpartnerListComponent = (props) => {

  const {t, partnerId, view, contactId, source} = props;
  const history = useHistory();
  const {id} = useParams();
  const [contactpartners, setContactpartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [moveDialogVisible, setMoveDialogVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [partners, setPartners] = useState([]);
  const [moveForm, setMoveForm] = useState({partner: null, position: ''});
  const [moveLoading, setMoveLoading] = useState(false);
  const [viewDialogVisible, setViewDialogVisible] = useState(false);
  const [viewRow, setViewRow] = useState(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams);
      if (contactId) {
        query += '&search[contact][operator]==&search[contact][value]=' + contactId;
      }
      apiCall('get', '/api/v2/contact-partner' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setContactpartners(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const saveMove = async () => {
    if (!selectedRow?.contact?.id || !moveForm.partner) {
      window.App.toastShow('error', t('error'), 'A partner kiválasztása kötelező.');
      return;
    }
    setMoveLoading(true);
    try {
      await apiCall('post', '/api/v2/contact-partner', {
        partner: Number(moveForm.partner),
        contact: selectedRow.contact.id,
        position: moveForm.position || null,
        active: true
      });
      if (Number(moveForm.partner) !== Number(partnerId) || (Number(moveForm.partner) === Number(partnerId) && (moveForm.position || '') !== (selectedRow.position || ''))) {
        await apiCall('patch', '/api/v2/contact-partner/' + selectedRow.id, {
          contact: selectedRow.contact?.id || selectedRow.contact,
          partner: selectedRow.partner?.id || selectedRow.partner || Number(partnerId),
          position: selectedRow.position || null,
          date_from: selectedRow.date_from || null,
          date_until: selectedRow.date_until || null,
          active: false
        });
      }
      window.App.toastShow('success', t('toastSaveSuccess'));
      setMoveDialogVisible(false);
      setSelectedRow(null);
      window.App.setState({rerenderContactpartnerList: Math.random()})
    } catch (error) {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    } finally {
      setMoveLoading(false);
    }
  };

  const actionBodyTemplate = (rowData) => {
    const rowContactId = rowData.contact?.id || rowData.contact;
    const rowPartnerId = rowData.partner?.id || rowData.partner || partnerId || id;
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <>
            <Button
              icon="pi pi-pencil"
              className="p-button-warning p-mr-2"
              tooltip={t('edit')}
              tooltipOptions={{position: 'left'}}
              onClick={() => {
                if (contactId) {
                  history.push(
                    '/partner/contact?read=contact' +
                    '&contactId=' + contactId +
                    '&update=contactpartner' +
                    '&contactPartnerId=' + rowData.id
                  );
                } else {
                  history.push(
                    '/partner/read/' + rowPartnerId +
                    '?update=contactpartner' +
                    '&contactPartnerId=' + rowData.id
                  );
                }
              }}
            />

            {source === 'partner' && (
              <Button
                icon="pi pi-eye"
                className="p-button p-mr-2"
                tooltip={t('view')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  setViewRow({
                    ...rowData,
                    rowContactId,
                    rowPartnerId
                  });
                  setViewDialogVisible(true);
                }}
              />
            )}
          </>
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderContactpartnerList])

  useEffect(() => {
    if (moveDialogVisible) {
      apiCall('get', '/api/v2/partner?item_per_page=1000')
        .then(response => {
          setPartners(response?.data?.data?.items || []);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }, [moveDialogVisible])

  return (
    <>

    
      <Dialog
        header={t('contactPartnerView')}
        visible={viewDialogVisible}
        style={{width: '95%'}}
        modal
        onHide={() => {
          setViewDialogVisible(false);
          setViewRow(null);
        }}
      >
        {viewRow && (
          <TabView className="tabview-header-icon menu" style={{ backgroundColor: 'white', border: 'none' }}>
            <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
              <div className="p-grid">
                <div className="p-col-12 p-lg-6">
                  <div className="p-grid">
                    <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                      <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                        {t('contactPartnerData')}
                      </h3>
                    </div>
                  </div>

                  <ContactShowComponent
                    key={viewRow.rowContactId}
                    contactId={viewRow.rowContactId}
                  />
                </div>

                <div className="p-col-12 p-lg-6">
                  <div className="p-grid">
                    <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                      <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                        {t('positions')}
                      </h3>
                    </div>
                  </div>

                  <ContactpartnerListComponent
                    t={t}
                    contactId={viewRow.rowContactId}
                    source="dialog"
                  />
                </div>
              </div>
            </TabPanel>
          </TabView>
        )}
      </Dialog>



      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={contactpartners} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        {/* {view === 'extended' && (
          <Column header={t('columnPersonalData')}
            body={(rowData) => (
              <div>
                <div><strong>{rowData.contact?.name || '-'}</strong></div>
                <small>{rowData.contact?.email || '-'}</small><br />
                <small>{rowData.contact?.phone || '-'}</small><br />
                <small>{rowData.contact?.note || '-'}</small>
              </div>
            )}
          />
        )} */}

        {view === 'extended' && (
          <Column header={t('columnPositionAtPartner')}
            body={(rowData) => (
              <div>
                <div><strong>{rowData.position || '-'}</strong></div>
                <small>Aktív: {rowData.active ? props.t('yes') : props.t('no')}</small><br />
                <small>{rowData.date_from || '-'} - {rowData.date_until || '-'}</small>
              </div>
            )}
          />
        )}

        {view !== 'extended' && <Column field="contact.name" header={t('columnName2')} sortable filter />}
        {view !== 'extended' && <Column field="contact.email" header={t('columnEmail')} sortable filter />}
        {view !== 'extended' && <Column field="contact.phone" header={t('columnPhone')} sortable filter />}
        {view !== 'extended' && <Column field="position" header={t('columnPosition')} sortable filter />}
        {view !== 'extended' && (
          <Column
            field="active"
            header={t('columnActive')}
            sortable
            className={"p-text-center"}
            body={(rowData) => (
              <span id={rowData.id}>
                {rowData.active === true ? (
                  <i className={"pi pi-check text-success"}></i>
                ) : (
                  <i className={"pi pi-times text-danger"}></i>
                )}
              </span>
            )}
          />
        )}

        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
      <Dialog header="Áthelyezés / új partnerkapcsolat" visible={moveDialogVisible} style={{width: '500px'}} modal onHide={() => {setMoveDialogVisible(false); setSelectedRow(null);}} footer={<><Button type="button" label="Mentés" icon="pi pi-save" className="p-button-success" loading={moveLoading} onClick={saveMove} /></>}>
        <div className="p-fluid">
          <div className="p-field">
            <label>{t('fieldPerson')}</label>
            <div><strong>{selectedRow?.contact?.name || '-'}</strong></div>
            <small>{selectedRow?.contact?.email || '-'}</small><br />
            <small>{selectedRow?.contact?.phone || '-'}</small>
          </div>
          <div className="p-field">
            <label htmlFor="move_partner">{t('columnPartner')}</label>
            <Dropdown id="move_partner" value={moveForm.partner} options={partners} optionLabel="name" optionValue="id" filter onChange={(e) => {setMoveForm({...moveForm, partner: e.value});}} />
          </div>
          <div className="p-field">
            <label htmlFor="move_position">{t('columnPosition')}</label>
            <InputText id="move_position" value={moveForm.position} onChange={(e) => {setMoveForm({...moveForm, position: e.target.value});}} />
          </div>
        </div>
      </Dialog>
    </>
  )
}
export default withTranslation('common')(ContactpartnerListComponent);
